module.exports = __webpack_public_path__ + "static/media/SSRb7737c58757f3c7bfe96d39c4b13cb28.webp";